import React from "react";
import useMetaTags from "../../hooks/useMetaTags";
// import Services_we_offer from '../../component/Services_Component/Services_we_offer';
import {
  AssistanceSection,
  BenefitSection,
  BoostSection,
  CustomSection,
  FAQ,
  LargeData,
  ServicesSection,
  roleWriting,
} from "../../Data/All_Services_Data/nodejsdevData";
import Custom_section from "../../component/Services_Component/Custom_services_section";
import Benefits_section from "../../component/Services_Component/Benefits_section";
import Boost_section from "../../component/Services_Component/Boost_section";
import Assistance_section from "../../component/Services_Component/Assistance_section";
import FAQ_section from "../../component/Services_Component/FAQ_section";
import Role_writing from "../../component/Services_Component/Role_writing";
import Handle_Largedata_section from "../../component/Services_Component/Handle_Largedata_section";

const NodeJsDevelopmentService = () => {
  useMetaTags({
    title: "Node.js Development Services/ warrgyizmorsch",
    description:
      "Warrgyizmorsch provides high-quality Node.js Development Services to develop quick, scalable, and secure apps that fuel business growth and digital innovation",
    keywords:
      "node development company, nodejs development company, node js development services, node js developers, hire node js developer, Node.js Development, Node.js web development, Node.js app development",
  });
  return (
    <>
      <section
        className=""
        style={{
          backgroundImage: `url('assets/img/service/serviceD.jpg')`,
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
        id="service-sec"
      >
        <div className="round-container pt-5">
          <div className="container">
            <div className="title-area text-center">
              <span className="sub-title text-white">OUR SERVICES</span>
              <h1 className="sec-title text-white">
                Node.js Development Services
              </h1>
            </div>
          </div>
        </div>
      </section>
      <section className="space-extra-bottom">
        <div className="page-single">
          <div className="page-content">
            <style>{`
                    .header-section{
            display: flex;
            align-items: center;
            gap: 20px;
            margin-bottom: 30px;
        }
        .header-section img{
            height: 400px;
        }
        .header-section p{
            text-align: left;
        }

        @media only screen and (max-width: 990px) {
        .header-section{
            flex-direction: column;
        }
        .header-section img{
            height: 200px;
        }
            .header-section p{
            text-align: center;
        }
        }
                `}</style>
            {/* Intro part  */}
            <div
              className="header-section container"
              style={{ marginTop: "20px" }}
            >
              <img
                src="assets/img/icon/nodeJs.png"
                loading="lazy"
                alt="heading_image"
              />
              <div>
                <p>
                  We at Warrgyizmorsch present full scale node development
                  company services which we put to use to build out fast,
                  scalable and high performing web and mobile apps. We are
                  dedicated to innovation, quality and seamless delivery which
                  we put to you for your digital transformation.
                </p>
              </div>
            </div>
            {/* Innovative Node.js Development Solutions */}
            <Handle_Largedata_section LargeData={LargeData} />

            {/* Why Opt For Node.js Development Services? */}
            <Benefits_section data={BenefitSection} />

            {/* Why Choose Warrgyizmorsch As Your Node.js Development Company? */}
            <Custom_section data={CustomSection} />

            {/* The Experts in Node.js Development  */}
            <Assistance_section data={AssistanceSection} />
            
            {/* FAQ section  */}
            <FAQ_section data={FAQ} />
          </div>
        </div>
      </section>
      <div className="scroll-top">
        <svg
          className="progress-circle svg-content"
          width="100%"
          height="100%"
          viewBox="-1 -1 102 102"
        >
          <path
            d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
            style={{
              transition: "stroke-dashoffset 10ms linear 0s",
              strokeDasharray: "307.919, 307.919",
              strokeDashoffset: "307.919",
            }}
          ></path>
        </svg>
      </div>
    </>
  );
};

export default NodeJsDevelopmentService;
